import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MarkerTemplatesActions } from '../../_actions';
import { Button, Icon, CustomMarker, PaneLoader } from '../../_components';
import { useModal } from '../../_contexts';
import ReactTooltip from 'react-tooltip';

const DEFAULT_PLACEHOLDER = 'Search Marker Templates';
const tooltipID = 'chronos-markertemplate-list-tooltip';
const tooltipIcon = 'far fa-question-circle fa-fw';
export function MarkerTemplatesListForm({
  placeholder = DEFAULT_PLACEHOLDER,
  hidePlaceholder,
  prevModal,
  worldID,
  hideControls,
}) {
  ReactTooltip.rebuild();

  const dispatch = useDispatch();

  const { openModal, closeModal } = useModal();

  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [availableTemplates, setAvailableTemplates] = useState([]);

  const { loading } = useSelector((state) => state.markerTemplates);

  const searchRef = useRef();

  const handleSearchChange = () => {
    if (searchRef.current) setSearchTerm(searchRef.current.value);
  };

  const handleNewTemplate = () => {
    console.log('Moving to new template!!');
    openModal('markerTemplateEditor', {
      prevModal: 'markerTemplateManager',
    });
  };

  const handleTemplateSelect = (template) => {
    console.log('Moving to edit template!');
    openModal('markerTemplateEditor', {
      prevModal: 'markerTemplateManager',
      item: template,
    });
  };

  const handleTemplateDelete = (template) => {
    openModal('confirmDelete', {
      prevModal: 'markerTemplateManager',
      type: 'markerTemplate',
      item: template,
    });
  };

  const handleCloseManager = () => {
    if (
      prevModal &&
      prevModal.length > 0 &&
      prevModal !== 'markerTemplateManager'
    ) {
      openModal(prevModal);
    } else {
      closeModal();
    }
  };

  useEffect(() => {
    if (searchTerm && searchTerm.length >= 3) {
      let filteredMarkerTemplates = availableTemplates.filter((template) => {
        if (
          template.name
            .toLocaleLowerCase()
            .includes(searchTerm.toLocaleLowerCase())
        ) {
          return true;
        }
        if (
          template.customClassName
            .toLocaleLowerCase()
            .includes(searchTerm.toLocaleLowerCase())
        ) {
          return true;
        }
        return false;
      });

      return setFilteredTemplates(
        filteredMarkerTemplates.length > 0 ? filteredMarkerTemplates : []
      );
    } else {
      setFilteredTemplates(
        !searchTerm || searchTerm.length === 0 ? availableTemplates : []
      );
    }
  }, [searchTerm, availableTemplates]);

  useEffect(() => {
    dispatch(MarkerTemplatesActions.getWorldTemplates(worldID))
      .then(setAvailableTemplates)
      .catch((error) => console.log('EEE: Error-', error));
  }, []);

  return (
    <div className="chronos-marker-template-manager">
      <div className="chronos-marker-template-search-content">
        <input
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          ref={searchRef}
          placeholder={hidePlaceholder ? '' : placeholder}
          className="form-control"
        />
        <Button color="primary" onClick={handleNewTemplate}>
          <Icon icon="far fa-plus fa-fw" />
          &nbsp;New Template
        </Button>
      </div>
      <div className="chronos-marker-templates-list">
        {filteredTemplates &&
          filteredTemplates.map((result) => {
            return (
              <MarkerTemplateSearchResult
                templateResult={result}
                key={result._id}
                onSelect={handleTemplateSelect}
                onDelete={handleTemplateDelete}
                showControls={!hideControls}
              />
            );
          })}
      </div>
      {!hideControls && (
        <div className="chronos-form-controls">
          <Button onClick={handleCloseManager} color="primary">
            <Icon icon="far fa-times fa-fw" />
            &nbsp;Close
          </Button>
        </div>
      )}
      <PaneLoader isLoading={loading} text="Marker Templates" />
      <ReactTooltip id={tooltipID} effect="solid" />
    </div>
  );
}

function MarkerTemplateSearchResult({
  templateResult,
  onSelect,
  onDelete,
  showControls = true,
}) {
  const handleSelect = () => {
    if (onSelect && showControls) onSelect(templateResult);
  };

  const handleDelete = () => {
    if (onDelete && showControls) onDelete(templateResult);
  };
  return (
    <div className="chronos-marker-template-list-item">
      {/* Custom Viewer */}
      <CustomMarker template={templateResult} />
      <div className="chronos-marker-template-description">
        <span className="chronos-result-list-title">{templateResult.name}</span>
        {showControls && (
          <span className="chronos-list-item-controls">
            <Button
              onClick={handleDelete}
              color="danger"
              size="xs"
              data-tip="Delete"
              data-for={tooltipID}
            >
              <Icon icon="far fa-trash fa-fw" />
            </Button>

            <Button
              onClick={handleSelect}
              color="info"
              size="xs"
              data-tip="Edit"
              data-for={tooltipID}
            >
              <Icon icon="far fa-arrow-right fa-fw" />
            </Button>
          </span>
        )}
      </div>
    </div>
  );
}
